import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || '';

export default function RegisterInvite() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);
  const [f, setF] = useState({ name: '', lastname: '', dni: '', address: '', city: '', phone: '', password: '' });
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));

  useEffect(() => {
    fetch(`${API}/api/public/invite/${token}`)
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(setInfo)
      .catch(() => setError('Esta invitación no es válida o ya fue usada.'));
  }, [token]);

  async function submit(e) {
    e.preventDefault();
    if (!f.name.trim() || !f.lastname.trim() || !f.password.trim()) { alert('Completá nombre, apellido y contraseña'); return; }
    setSaving(true);
    try {
      const r = await fetch(`${API}/api/public/invite/${token}/accept`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(f),
      });
      const d = await r.json();
      if (!r.ok) { alert(d.error || 'No se pudo completar'); return; }
      setDone(true);
    } catch { alert('Error de conexión'); } finally { setSaving(false); }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src={info?.logo_url || '/assets/tukipass-icon.png'} alt="" style={{ height: 42 }} onError={e => { e.target.src = '/assets/tukipass-icon.png'; }} />
        </div>

        {error && <div className="lb-card" style={{ padding: 26, textAlign: 'center', color: 'var(--red-300)' }}>{error}</div>}

        {!error && !info && <div style={{ color: 'var(--ink-600)', textAlign: 'center' }}>Cargando…</div>}

        {!error && info && done && (
          <div className="lb-card" style={{ padding: 28, textAlign: 'center' }}>
            <div style={{ fontSize: 42, marginBottom: 8 }}>✓</div>
            <div className="lb-h" style={{ fontSize: 20 }}>¡Registro completo!</div>
            <p style={{ color: 'var(--ink-700)', fontSize: 14 }}>Ya podés ingresar con tu email y la contraseña que elegiste.</p>
            <a href="/admin" className="lb-btn lb-btn--primary lb-btn--block" style={{ marginTop: 12 }}>Ir a ingresar →</a>
          </div>
        )}

        {!error && info && !done && (
          <div className="lb-card" style={{ padding: '28px 26px' }}>
            <div className="lb-eyebrow">Completá tu registro</div>
            <p style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 6 }}>
              Fuiste designado como <b style={{ color: 'var(--red-400)' }}>{info.role_label}</b> en {info.org_name}.
            </p>
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 12 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <F label="Nombre"><input className="lb-input" value={f.name} onChange={e => set('name', e.target.value)} required /></F>
                <F label="Apellido"><input className="lb-input" value={f.lastname} onChange={e => set('lastname', e.target.value)} required /></F>
              </div>
              <F label="Email"><input className="lb-input" value={info.email} disabled /></F>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <F label="DNI"><input className="lb-input" inputMode="numeric" value={f.dni} onChange={e => set('dni', e.target.value.replace(/\D/g, ''))} /></F>
                <F label="Teléfono"><input className="lb-input" inputMode="tel" value={f.phone} onChange={e => set('phone', e.target.value)} /></F>
              </div>
              <F label="Dirección"><input className="lb-input" value={f.address} onChange={e => set('address', e.target.value)} /></F>
              <F label="Localidad"><input className="lb-input" value={f.city} onChange={e => set('city', e.target.value)} /></F>
              <F label="Contraseña (para ingresar)"><input className="lb-input" type="password" value={f.password} onChange={e => set('password', e.target.value)} required /></F>
              <button className="lb-btn lb-btn--primary lb-btn--block" type="submit" disabled={saving} style={{ marginTop: 6 }}>{saving ? 'Guardando…' : 'Completar registro →'}</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

function F({ label, children }) {
  return <div className="lb-field"><div className="lb-label">{label}</div>{children}</div>;
}
